import { makeStyles } from "@material-ui/core";


export const useStyles = makeStyles(((theme) => ({
    formWrapper: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    formColumn: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(1),
    },
    saveButton: {
        padding: '0 36px',
        marginTop: theme.spacing(1.5),
        marginLeft: 'auto',
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
        },
    },
    loadedCredentialsWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(1),
    }
})));